import React, { createContext, useContext, useState, useEffect } from 'react';

const FontContext = createContext();

export const useFontSize = () => {
  const context = useContext(FontContext);
  if (!context) {
    throw new Error('useFontSize must be used within a FontProvider');
  }
  return context;
};

// Font size mappings
const fontSizeClasses = {
  small: {
    text: 'text-xs',
    heading: 'text-sm',
    title: 'text-base',
    subtitle: 'text-sm'
  },
  medium: {
    text: 'text-sm', 
    heading: 'text-base',
    title: 'text-lg',
    subtitle: 'text-base'
  },
  large: {
    text: 'text-base',
    heading: 'text-lg', 
    title: 'text-xl',
    subtitle: 'text-lg'
  }
};

export const FontProvider = ({ children }) => {
  const [fontSize, setFontSize] = useState(() => {
    const savedFontSize = localStorage.getItem('helpdesk_font_size');
    return savedFontSize || 'medium';
  });

  const changeFontSize = (newSize) => {
    if (fontSizeClasses[newSize]) {
      setFontSize(newSize);
      localStorage.setItem('helpdesk_font_size', newSize);
    }
  };

  const getFontClass = (type = 'text') => {
    return fontSizeClasses[fontSize][type] || fontSizeClasses.medium[type];
  };

  useEffect(() => {
    // Add font size class to document root
    document.documentElement.setAttribute('data-font-size', fontSize);
  }, [fontSize]);

  return (
    <FontContext.Provider value={{
      fontSize,
      changeFontSize,
      getFontClass,
      fontSizes: Object.keys(fontSizeClasses)
    }}>
      {children}
    </FontContext.Provider>
  );
};